import { resetState } from '../Redux/file-list-slice.js';

const resetStateMiddleware = (store) => (next) => (action) => {
	if (action.type === '@@redux/INIT' && !window.localStorage.getItem('AUTHKEY')) {
		store.dispatch(resetState());
	}

	return next(action);
};

export default resetStateMiddleware;
